export default __webpack_public_path__ + "static/media/sparkles-no-3.d95b7c9c.ogg";